import React from 'react';
import { Loading, Empty } from './styles';

const WarehousesContainer = ({ children, loading, warehouses }) => {
  if (loading) {
    return <Loading>{children}</Loading>;
  }

  if (!warehouses?.length) {
    return <Empty>{children}</Empty>;
  }

  return <div>{children}</div>;
};

export default WarehousesContainer;
